const MIME_BMP = 'image/bmp';
const MIME_JPEG = 'image/jpeg';
const MIME_PNG = 'image/png';

const mime = {
  MIME_BMP,
  MIME_JPEG,
  MIME_PNG
};

export { MIME_BMP, MIME_JPEG, MIME_PNG };

export default mime;
